import { useLanguageContext } from 'Context';
import { useMemo } from 'react';
import { THEME_COLORS } from 'UIShared';
import { HeaderViewProps } from '../types';

export function useHeaderController(
  error: HeaderViewProps['error'],
  success: HeaderViewProps['success'],
  isRequired: HeaderViewProps['isRequired']
) {
  const language = useLanguageContext();

  const color: keyof THEME_COLORS = useMemo(() => {
    if (error) {
      return 'error-text-color';
    } else if (success) {
      return 'success-text-color';
    }
    return 'input-border';
  }, [error, success]);

  const text = useMemo(
    () =>
      language?.getTranslate(
        isRequired ? 'ui.support.required' : 'ui.support.optional'
      ),
    [isRequired, language]
  );

  return { color, text };
}
